export default "__VITE_ASSET__DeVtnWBG__"